import { contactInfoFolders, hobbiesFolders, personalInfoFolders, professionalInfoFolders } from "./folders";

export const careerSections = [
  {
    title: 'professional-info',
    folders: professionalInfoFolders
  }
];

export const personalInfoSections = [
  {
    title: 'personal-info',
    folders: personalInfoFolders
  },
  {
    title: 'contact-info',
    folders: contactInfoFolders
  }
];

export const hobbySections = [
  {
    title: 'hobbies',
    folders: hobbiesFolders
  }
];
